export const STATS = 'stats' as const
export const STATS_WEB = 'stats_web' as const
export const GLOBAL_STATE = 'Stats' as const
